import React from 'react';

interface TaMoAkiLogoProps {
  size?: 'sm' | 'md' | 'lg' | 'xl' | 'custom';
  customSize?: string;
  className?: string;
  showText?: boolean;
  noBg?: boolean;
}

const TaMoAkiLogo: React.FC<TaMoAkiLogoProps> = ({ 
  size = 'md', 
  customSize, 
  className = '',
  showText = false,
  noBg = false
}) => {
  const getSizeClasses = () => {
    switch (size) {
      case 'sm':
        return 'w-16 h-16';
      case 'md':
        return 'w-24 h-24';
      case 'lg':
        return 'w-32 h-32';
      case 'xl':
        return 'w-40 h-40';
      case 'custom':
        return customSize || 'w-24 h-24';
      default:
        return 'w-24 h-24';
    }
  };

  const getTextSize = () => {
    switch (size) {
      case 'sm':
        return 'text-sm';
      case 'md':
        return 'text-lg';
      case 'lg':
        return 'text-xl';
      case 'xl':
        return 'text-2xl';
      case 'custom':
        return 'text-lg';
      default:
        return 'text-lg';
    }
  };

  return (
    <div className={`flex items-center space-x-2 ${className}`}>
      <div className={`${getSizeClasses()} flex items-center justify-center overflow-hidden`}>
        <img 
          src="/images/branding/tamoaki_logo_new.png" 
          alt="TaMoAki Logo" 
          className="w-full h-full object-contain"
          onError={(e) => {
            console.error('Erro ao carregar logo:', e);
            // Fallback para o logo anterior se o novo falhar
            e.currentTarget.src = '/images/branding/tamoaki_logo.png';
          }}
        />
      </div>
      {showText && (
        <span className={`${getTextSize()} font-bold bg-gradient-to-r from-orange-600 to-blue-600 bg-clip-text text-transparent`}>
          TaMoAki
        </span>
      )}
    </div>
  );
};

export default TaMoAkiLogo; 